import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/core/service/app.service";
import { AuthService } from "src/app/core/service/auth.service";
import { DoctorService } from "src/app/doctor/doctor.service";
import { DmsDocument } from "../../models/dms-document";
import { DoctorDetails } from "../../models/doctorDetails";
import { UserAccount } from "../../models/user-account";
import { saveAs } from "file-saver";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { userRole } from "../../userRole";
import { MatDialog } from "@angular/material/dialog";
import PharmcistService from "src/app/pharmacist/pharmcist.service";
import { NotificationService } from "../../notification.service";
import { RejectDoctorComponent } from "src/app/pharmacist/doctor/components/reject-doctor/reject-doctor.component";
import { Location } from "@angular/common";
import { ActivityType } from "../../ActivityType";

@Component({
  selector: "app-view-profile",
  templateUrl: "./view-profile.component.html",
  styleUrls: ["./view-profile.component.sass"],
})
export class ViewProfileComponent implements OnInit {
  public userAccount: any;
  public doctorDetails: DoctorDetails = null;
  currentUser: UserAccount;
  dmsDocument: DmsDocument;
  imgSrc: any;
  finalURL: string;
  loginUser: UserAccount;
  address = "";
  mailto = "mailto:";
  pendingRecords: Array<DoctorDetails>;
  pendingDoctorsCount: any;
  @ViewChild("ApproveDoctorComponent")
  doctorApproveConfirm: TemplateRef<any>;
  collectionLocation: any;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    public doctorService: DoctorService,
    public spinner: NgxSpinnerService,
    public appService: AppService,
    public sanitizer: DomSanitizer,
    public router: Router,
    public dialog: MatDialog,
    public pharmacistService: PharmcistService,
    public notificationService: NotificationService,
    public location: Location
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
    this.userAccount = new UserAccount();
    this.userAccount = this.currentUser;
    this.doctorDetails = new DoctorDetails();
    this.dmsDocument = new DmsDocument();
    this.loginUser = new UserAccount();
    this.pendingRecords = new Array<DoctorDetails>();
  }

  ngOnInit(): void {
    // this.getCurrentUserDetails();
    if (this.router.url.includes("?")) {
      this.finalURL = this.router.url.split("?")[1];
      this.finalURL = this.finalURL.slice(0, -1);
      this.GetDoctorDetiail(this.finalURL);
    } else {
      this.GetAddress();
      this.getProfilePicture(this.currentUser.ProfilePictureId);
      if (this.userAccount.UserRoleId == userRole.doctor) {
        this.GetDoctorDetiail(this.userAccount.Id);
      }
      else{
        this.getCollectionLocation();
      }
      this.loginUser = this.currentUser;
      this.userAccount = this.currentUser;
      
    }
  }

  getCurrentUserDetails() {
    const user = { Id: this.currentUser.Id };
    this.appService.getUser(user).subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          res.DateOfBirth =
            res.DateOfBirth !== null ? new Date(res.DateOfBirth) : null;
          this.userAccount =
            res !== undefined && res !== null ? res : new UserAccount();
          this.currentUser = res;
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  GetDoctorDetiail(id: any) {
    var doctorDetails = {
      doctorAccountId: id,
    };
    this.spinner.show();
    this.doctorService.GetDoctorDetailsById(doctorDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.doctorDetails = resp;
          this.doctorDetails.doctor.Qualification = this.doctorDetails.doctor.Qualification?.replace(
            /,/g,
            ", "
          );
          this.doctorDetails.doctor.Specialization = this.doctorDetails.doctor.Specialization?.replace(
            /,/g,
            ", "
          );
          this.userAccount = resp?.userAccount;
          if (this.loginUser.Id != this.userAccount.Id) {
            this.mailto = this.mailto + this.userAccount.Email;
          }
          this.GetAddress();
          this.getProfilePicture(this.userAccount.ProfilePictureId);
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  GetDoctorDetiails() {
    var doctorDetails = {
      doctorAccountId: this.currentUser.Id,
    };
    this.spinner.show();
    this.doctorService.GetDoctorDetailsById(doctorDetails).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
          this.doctorDetails = resp;
          this.userAccount = resp?.userAccount;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  DownloadDoctorDocument(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.dmsDocument = res;
        const blob = this.b64toBlob(this.dmsDocument);
        saveAs(blob, this.dmsDocument.FileName);
        const url = window.URL.createObjectURL(blob);
        if(this.dmsDocument.FileExtension != '.pdf')
        {
          window.open(url);
          window.URL.revokeObjectURL(url);
        }
      }
    });
  }

  b64toBlob(document) {
    this.dmsDocument = document;
    const byteString = atob(this.dmsDocument.Base64Url.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArr = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      intArr[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: this.dmsDocument.DocumentType });
  }

  goBack() {
    this.authService.goBack();
  }
  getProfilePicture(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.dmsDocument = Object.assign({}, res);
        if (this.dmsDocument.Base64Url) {
          this.imgSrc = this.getSantizeUrl(this.dmsDocument.Base64Url);
          this.imgSrc !== 0 ? this.imgSrc : "./assets/images/default-user.png";
        }
      } else {
        // if (this.userAccount.UserRoleId == "pharmacy") {
        //   this.imgSrc = "./assets/images/pages/logo-1.jpg";
        // } else
        if (
          this.userAccount.UserRoleId == userRole.pharmacist ||
          this.userAccount.UserRoleId == userRole.pharmacistSubAdmin
        ) {
          this.imgSrc = "./././assets/images/user/user-1.png";
        } else if (this.userAccount.UserRoleId == userRole.doctor) {
          this.imgSrc = "./././assets/images/user/dr.png";
        }
      }
    });
  }

  public getSantizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  GetRole(roleId) {
    if (roleId == 1) {
      return "Admin";
    } else if (roleId == 2) {
      return "Doctor";
    } else if (roleId == 3) {
      return "Admin";
    } else if (roleId == 4) {
      return "Pharmacist";
    }
  }

  GetAddress() {
    if (
      this.userAccount.AddressLine1 != null &&
      this.userAccount.AddressLine1 != "" &&
      this.userAccount.AddressLine1 != undefined
    ) {
      this.address = this.userAccount.AddressLine1 + ", ";
    }
    if (
      this.userAccount.AddressLine2 != null &&
      this.userAccount.AddressLine2 != "" &&
      this.userAccount.AddressLine2 != undefined
    ) {
      this.address = this.address + this.userAccount.AddressLine2 + ", ";
    }
    if (
      this.userAccount.City != null &&
      this.userAccount.City != "" &&
      this.userAccount.City != undefined
    ) {
      this.address = this.address + this.userAccount.City + ", ";
    }
    if (
      this.userAccount.State != null &&
      this.userAccount.State != "" &&
      this.userAccount.State != undefined
    ) {
      this.address = this.address + this.userAccount.State + ", ";
    }
    if (
      this.userAccount.Country != null &&
      this.userAccount.Country != "" &&
      this.userAccount.Country != undefined
    ) {
      this.address = this.address + this.userAccount.Country + ".";
    }
  }

  approveDoctor() {
    const dialogRef = this.dialog.open(this.doctorApproveConfirm, {
      data: {
        doctor: this.doctorDetails,
        action: "approve",
      },
      disableClose: true,
    });
    this.doctorDetails = this.doctorDetails;
  }

  ApproveDoctor() {
    this.spinner.show();
    this.doctorDetails.doctor.IsApproved = "APPROVED";
    var doctorDetails = {
      doctorDetails: this.doctorDetails.doctor,
    };
    this.pharmacistService.ChangeDoctorStatus(doctorDetails).subscribe({
      next: (resp: any) => {
        if (!resp.hasErrors) {
          this.pendingRecords = resp?.Records;
          this.authService.showNotification(
            "snackbar-success",
            "Doctor approved successfully!",
            "top",
            "center"
          );
          this.pendingDoctorsCount = this.pendingRecords?.length;
          this.pharmacistService.pendingDoctorsCount.next(
            this.pendingDoctorsCount
          );
          this.location.back();
          // var title = "Doctor has been approved";
          // var description =
          //   "Dr." +
          //   this.doctorDetails.userAccount.FirstName +
          //   this.doctorDetails.userAccount.LastName +
          //   " has been approved";
          // this.AddNotification(title, description);
          this.closeDialog();
          this.AddUserActivity(
            ActivityType.DoctorApproved,
            "Doctor Approved",
            "Doctor approved by " +
              this.currentUser.FirstName +
              " " +
              this.currentUser.LastName
          );
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  closeDialog(): void {
    this.dialog.closeAll();
  }
  rejectDoctor() {
    // this.id = this.doctorDetails.do;
    this.doctorDetails = this.doctorDetails;
    const dialogRef = this.dialog.open(RejectDoctorComponent, {
      data: {
        doctor: this.doctorDetails,
        action: "reject",
      },
      maxWidth: "750px",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      //for delete we use splice in order to remove single object from DataService
      if (result == 1) {
        this.authService.showNotification(
          "snackbar-success",
          "Doctor rejected successfully.",
          "top",
          "center"
        );
        this.pendingDoctorsCount = this.pendingRecords?.length;
        this.pharmacistService.pendingDoctorsCount.next(
          this.pendingDoctorsCount
        );
        this.AddUserActivity(
          ActivityType.DoctorReject,
          "Doctor Rejected",
          "Doctor rejected by " +
            this.currentUser.FirstName +
            " " +
            this.currentUser.LastName
        );
        this.location.back();
        // var title = "Doctor has been rejected";
        // var description =
        //   "Dr." +
        //   this.doctorDetails.userAccount.FirstName +
        //   this.doctorDetails.userAccount.LastName +
        //   " has been rejected";
        // this.AddNotification(title, description);
      }
    });
  }

  AddUserActivity(activityType, activityName, description) {
    var userActivity = {
      ActivityType: activityType,
      ActivityName: activityName,
      UserName: this.currentUser.FirstName + " " + this.currentUser.LastName,
      Description: description,
      UserAccountId: this.currentUser.Id,
    };
    this.appService.AddUserActivity(userActivity).subscribe({
      next: (resp: any) => {
        if (!resp.HasErrors) {
        }
      },
      error: () => {},
    });
  }
  
  getCollectionLocation() {
  if(this.currentUser.UserRoleId != 2)
  {
    const doc = 
    { 
      collectionLocation: 
      {
        userAccountId: this.currentUser.Id
      }
    };
    this.appService.getCollectionlocations(doc).subscribe((res: any) => {
      if (!res.HasErrors && res.CollectionLocation != undefined) {
          this.collectionLocation = res.CollectionLocation;
             // var newtag = this.collectionLocation.replace('\r\n',"");
             this.collectionLocation = JSON.parse(this.collectionLocation)
             this.collectionLocation = Object?.values(this.collectionLocation)
            //  this.collectionLocationkey = Object.keys(JSON.parse(res.CollectionLocation))
      }
    });
  }
}
}
